import { render } from "./CreateReflectionView.vue?vue&type=template&id=64db9dd0"
import script from "./CreateReflectionView.vue?vue&type=script&lang=js"
export * from "./CreateReflectionView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__